import * as Sentry from "@sentry/browser";

const MAX_ENTRIES = 50;
const log = [];

function addEntry(level, message, data = {}) {
  const entry = {
    timestamp: new Date().toISOString(),
    level,
    message,
    ...data,
  };

  log.push(entry);

  // Keep the buffer from growing forever
  if (log.length > MAX_ENTRIES) {
    log.shift();
  }

  // Print to console in development only
  if (process.env.NODE_ENV === "development") {
    console[level](`[Auth] ${message}`, data);
  }
}

export const authLogger = {
  info: (message, data) => addEntry("info", message, data),
  warn: (message, data) => addEntry("warn", message, data),
  error: (message, data) => addEntry("error", message, data),

  // Call this when something actually goes wrong.
  // Dumps the full session history to Sentry as breadcrumbs so you can
  // see the full auth lifecycle leading up to the failure.
  flush: (error) => {
    log.forEach((entry) => {
      Sentry.addBreadcrumb({
        category: "auth",
        message: entry.message,
        level: entry.level,
        timestamp: new Date(entry.timestamp).getTime() / 1000,
        data: entry,
      });
    });

    Sentry.captureException(error);
  },
};
